import { CommonModule as AngularCommonModule } from '@angular/common';
import { Injectable, NgModule, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CoreLoginGuard,
  CorePageModule,
  CorePageModuleIDs
} from '@bepatient/core';
import { IonicModule } from '@ionic/angular';
import { OnboardingForgotIDPopupComponent } from './components/forgot-id-popup/onboarding-forgot-id-popup.component';
import { OnboardingPasswordPopupComponent } from './components/password-popup/onboarding-password-popup.component';
import { OnboardingValidationPopupComponent } from './components/validation-popup/onboarding-validation-popup.component';
import { Store } from '@ngrx/store';

@Injectable()
export class OnboardingLoginGuard extends CoreLoginGuard {
  constructor() {
    const store = inject<Store<any>>(Store);
    const router = inject(Router);

    super(store, router);
  }
}

const onboardingModule: CorePageModule = {
  ID: CorePageModuleIDs.ONBOARDING,
  routes: [
    {
      path: 'onboarding-login',
      loadChildren: () =>
        import('./pages/swipe-login/swipe-login.module').then(
          m => m.SwipeLoginPageModule
        ),
      canActivate: [OnboardingLoginGuard]
    },
    {
      path: 'onboarding-email',
      loadChildren: () =>
        import('./pages/email/email.module').then(m => m.EmailPageModule)
    },
    {
      path: 'onboarding-password',
      loadChildren: () =>
        import('./pages/password/password.module').then(
          m => m.PasswordPageModule
        )
    },
    {
      path: 'onboarding-password-forgotten',
      loadChildren: () =>
        import('./pages/password-forgotten/password-forgotten.module').then(
          m => m.OnboardingPasswordForgottenPageModule
        )
    },
    {
      path: 'onboarding-password-reset',
      loadChildren: () =>
        import('./pages/password-reset/password-reset.module').then(
          m => m.PasswordResetPageModule
        )
    },
    {
      path: 'onboarding-password-changed',
      loadChildren: () =>
        import('./pages/password-changed/password-changed.module').then(
          m => m.OnboardingPasswordChangedPageModule
        )
    },
    {
      path: 'onboarding-birthdate',
      loadChildren: () =>
        import('./pages/birthdate/birthdate.module').then(
          m => m.BirthdatePageModule
        )
    },
    {
      path: 'onboarding-password-reset-birthdate',
      loadChildren: () =>
        import(
          './pages/password-reset-birthdate/password-reset-birthdate.module'
        ).then(m => m.PasswordResetBirthdatePageModule)
    },
    {
      path: 'onboarding-steps',
      loadChildren: () =>
        import('./pages/steps/steps.module').then(m => m.StepsPageModule),
      canActivate: [OnboardingLoginGuard]
    },
    {
      path: 'onboarding-details-tos',
      loadChildren: () =>
        import('./pages/details-tos/details-tos.module').then(
          m => m.DetailsTosPageModule
        )
    },
    {
      path: 'onboarding-login-old',
      loadChildren: () =>
        import('./pages/login/login.module').then(m => m.LoginPageModule)
    }
  ]
};

@NgModule({
  imports: [
    AngularCommonModule,
    RouterModule.forChild(onboardingModule.routes),
    IonicModule,
    ReactiveFormsModule
  ],
  providers: [
    OnboardingLoginGuard,
    { provide: CORE_PAGE_MODULE, useValue: onboardingModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './onboarding/i18n/', multi: true }
  ],
  declarations: [
    OnboardingPasswordPopupComponent,
    OnboardingValidationPopupComponent,
    OnboardingForgotIDPopupComponent
  ],
  exports: [
    OnboardingPasswordPopupComponent,
    OnboardingValidationPopupComponent,
    OnboardingForgotIDPopupComponent
  ]
})
export class OnboardingModule {}
